import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initial: 'M',
  color: 'bg-blue-100 text-blue-700',
  name: 'Mariana G.',
  location: 'Mamá de Sofía, 5 años',
  text: 'Mi hija reconocía todas las letras. Todas. Pero cuando intentaba leer una palabra completa se quedaba congelada. Pensé que algo estaba mal. Hoy ya puede leer pequeñas frases sola y lo mejor es que volvió a confiar en ella misma.'
}, {
  initial: 'L',
  color: 'bg-emerald-100 text-emerald-700',
  name: 'Laura S.',
  location: 'Mamá de Tomás, 6 años',
  text: 'Cada tarde terminaba igual: frustración, cansancio y lágrimas. Yo no sabía cómo enseñarle. Este sistema me mostró exactamente qué hacer y en qué orden.'
}, {
  initial: 'F',
  color: 'bg-amber-100 text-amber-700',
  name: 'Fernando R.',
  location: 'Papá de Mateo, 6 años',
  text: 'Lo que más me gustó fue que no tuve que improvisar. Todo estaba organizado paso a paso. Mi hijo pasó de leer sílabas aisladas a leer palabras completas.'
}];
export function TestimonialsTop() {
  return <section className="py-12 md:py-16 bg-slate-50" data-id="element-299">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-300">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-301">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-white rounded-2xl p-8 shadow-xl shadow-slate-200/50 border border-slate-100 flex flex-col h-full relative" data-id="element-302">
              <div className="flex text-gold mb-6" data-id="element-303">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-304" />)}
              </div>

              <p className="text-slate-700 text-lg leading-relaxed mb-8 flex-grow italic" data-id="element-305">
                "{t.text}"
              </p>

              <div className="flex items-center mt-auto pt-6 border-t border-slate-100" data-id="element-306">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl ${t.color} mr-4 flex-shrink-0`} data-id="element-307">
                  {t.initial}
                </div>
                <div data-id="element-308">
                  <div className="font-bold text-navy" data-id="element-309">{t.name}</div>
                  <div className="text-sm text-slate-500" data-id="element-310">{t.location}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}